<div class="password-validation">
  @for (requirement of passwordRequirements(); track requirement) {
    <div class="requirement">
      <i [ngClass]="requirement.valid ? 'icon-Check' : 'icon-X'"></i>
      <span [class.valid]="requirement.valid">{{ requirement.text |translate }}</span>
    </div>
  }
</div>
